var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "innerWrapper" }, [
      _c("h1", [_vm._v("Affliated companies")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod\n      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim\n      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea\n      commodo consequat.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Removalists")]),
      _vm._v(" "),
      _c("ul", { staticClass: "clear" }, [
        _c("li", [_c("div", { staticClass: "img a" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img b" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img c" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img d" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img e" })])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Electricity providers")]),
      _vm._v(" "),
      _c("ul", { staticClass: "clear" }, [
        _c("li", [_c("div", { staticClass: "img f" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img g" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img h" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img i" })])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Gas providers")]),
      _vm._v(" "),
      _c("ul", { staticClass: "clear" }, [
        _c("li", [_c("div", { staticClass: "img f" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img g" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img h" })]),
        _vm._v(" "),
        _c("li", [_c("div", { staticClass: "img i" })])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07efa0ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07efa0ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more/affiliate.vue
// module id = null
// module chunks = 